export default __webpack_public_path__ + "static/media/6.8d8d49de.png";